
import { FirecrawlService } from "@/services/FirecrawlService";
import { useToast } from "@/components/ui/use-toast";
import { transformRecipeData } from "@/utils/recipe";
import { SubscriptionService } from "@/services/subscription";

export const useTransformation = (
  user: any,
  setIsLoading: (loading: boolean) => void,
  setRecipeData: (data: any) => void,
  onLoadSubscriptionStatus: (userId: string) => Promise<any>,
  forceRefresh?: () => void,
  lastCheckedStatus?: any,
  setLastCheckedStatus?: (status: any) => void,
  isCheckingSubscriptionRef?: React.MutableRefObject<boolean>
) => {
  const { toast } = useToast();

  const startTransformation = async (url: string) => {
    setIsLoading(true);
    try {
      // Check if user has active subscription
      const confirmedActive = localStorage.getItem('subscription_confirmed_active') === 'true';
      const currentStatus = lastCheckedStatus;
      
      // If not subscribed but has free transforms, decrement them
      if (!confirmedActive && !currentStatus?.isActive && 
          currentStatus?.remainingFreeTransforms !== undefined && 
          currentStatus?.remainingFreeTransforms > 0) {
        console.log('Decrementing free transform count');
        await SubscriptionService.decrementFreeTransforms(user.id);
        
        // Force refresh subscription status to update the counter
        if (isCheckingSubscriptionRef && !isCheckingSubscriptionRef.current && onLoadSubscriptionStatus) {
          isCheckingSubscriptionRef.current = true;
          const updatedStatus = await onLoadSubscriptionStatus(user.id);
          isCheckingSubscriptionRef.current = false;
          
          // Update the lastCheckedStatus with the new count
          if (updatedStatus && setLastCheckedStatus) {
            setLastCheckedStatus(updatedStatus);
          }
        }
      } else if (currentStatus?.isActive || confirmedActive) {
        console.log('User has active subscription, proceeding without decrementing');
      }

      const data = await FirecrawlService.scrapeRecipe(url);
      const transformedData = transformRecipeData(data);
      
      setRecipeData(transformedData);
      toast({
        title: "Success!",
        description: "Recipe transformed successfully!",
      });
      
      // Force refresh subscription status after transaction to ensure counter is updated
      if (forceRefresh && !confirmedActive && !currentStatus?.isActive) {
        setTimeout(() => {
          forceRefresh();
        }, 1000);
      }
    } catch (error) {
      console.error('Error fetching recipe:', error);
      toast({
        title: "Oops!",
        description: "Couldn't fetch the recipe. Please try again!",
        variant: "destructive",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return { startTransformation };
};
